import { c as _c } from "react/compiler-runtime";
import type { CartItemAccommodation } from '@feat/feat-cart/cart';
import type { PropsWithChildren } from 'react';
import { AccommodationOfferMicrodata, AccommodationSoldOutMicrodata } from 'src/lib/hotel-ads/microdata';
type CartAccommodationOfferMicrodataProps = PropsWithChildren<{
  item: CartItemAccommodation;
  taxIncluded: boolean;
}>;
export function CartAccommodationOfferMicrodata(t0) {
  const $ = _c(14);
  const {
    item,
    taxIncluded,
    children
  } = t0;
  const t1 = item.childrenAges?.length ?? 0;
  let t2;
  if ($[0] !== item.adultCount || $[1] !== item.checkin || $[2] !== item.checkout || $[3] !== t1) {
    t2 = {
      checkin: item.checkin,
      checkout: item.checkout,
      adults: item.adultCount,
      childCount: t1
    };
    $[0] = item.adultCount;
    $[1] = item.checkin;
    $[2] = item.checkout;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const stay = t2;
  if (item.statusAccommodation !== "AVAILABLE") {
    let t3;
    if ($[5] !== stay) {
      t3 = <AccommodationSoldOutMicrodata {...stay} />;
      $[5] = stay;
      $[6] = t3;
    } else {
      t3 = $[6];
    }
    let t4;
    if ($[7] !== children || $[8] !== t3) {
      t4 = <>{t3}{children}</>;
      $[7] = children;
      $[8] = t3;
      $[9] = t4;
    } else {
      t4 = $[9];
    }
    return t4;
  }
  let t3;
  if ($[10] !== children || $[11] !== stay || $[12] !== taxIncluded) {
    t3 = <AccommodationOfferMicrodata {...stay} taxIncluded={taxIncluded}>{children}</AccommodationOfferMicrodata>;
    $[10] = children;
    $[11] = stay;
    $[12] = taxIncluded;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  return t3;
}